import React from "react";
import PropTypes from "prop-types";

const Materialicon = ({ icon }) => (
	<i className="material-icons" >{icon}</i>
);
Materialicon.propTypes = {
	icon: PropTypes.string.isRequired
};
export default Materialicon;


// WEBPACK FOOTER //
// ./src/components/helpers/Materialicon.js